<onyx-modal
  variant="center"
  [size]="480"
  color="gray"
  [heading]="
    I18N +
    '.heading.' +
    (formStep() === FormStep.CATEGORY ? 'selectCategory' : category())
  "
  [close$]="close$"
  (keydown.enter)="disabled() ? null : continue()"
  (closeModal)="dialogRef.close()"
>
  <div class="items" [formGroup]="form" [onyxAutoFocus]="true">
    @let source =
      formStep() === FormStep.CATEGORY ? (categories$ | async) : types();
    @for (item of source; track item.value) {
      <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
      <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
      <div
        class="item"
        [class.active]="
          item.value ===
          (formStep() === FormStep.CATEGORY ? category() : type())
        "
        (click)="
          (formStep() === FormStep.CATEGORY
            ? categoryControl
            : typeControl
          ).setValue(item.value)
        "
      >
        @if (formStep() === FormStep.CATEGORY) {
          <onyx-icon
            [name]="getFleetIcon($any(item.value))"
            [size]="24"
          ></onyx-icon>
        }

        <p class="f-body-l">{{ item.name }}</p>

        @let controls = form.controls;
        <onyx-radio-button
          [attr.data-testid]="`${item.value}-radio-button`"
          [formControl]="
            formStep() === FormStep.CATEGORY ? controls.category : controls.type
          "
          [option]="item.value"
          [size]="24"
        ></onyx-radio-button>
      </div>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="back()">
      {{
        (formStep() === FormStep.CATEGORY ? 'labels.cancel' : 'labels.back')
          | translate
      }}
    </onyx-button>

    <onyx-button
      data-testid="continue-button"
      [spinner]="loading()"
      [disabled]="disabled()"
      (click)="disabled() ? null : continue()"
    >
      {{ 'labels.continue' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
